export var leadDashboardPageSize = 50;
export var leadDashboardInitialPageSize = 50;
